import type { MePayload } from "@/lib/types";

// Operator (global admin) coaching-content boundary: feedback authoring is
// gated PURELY on the active membership's `coach_object:write` capability —
// NOT on `is_global_admin`. The operator administers the system but cannot
// author or read coaching content; the backend 403s it on every `/api/coach/*`
// route, so the UI must not surface the authoring tabs to it either (a tab
// that errors on click is a broken UX). See docs/PRIVACY.md "Operator (global
// admin) coaching-content boundary".
export function canAuthorCoachFeedback(
  me: MePayload | null | undefined,
): boolean {
  return !!me?.active_scope?.capabilities?.includes("coach_object:write");
}

